
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import notificationService from "services/notification.service";
import {
  getRequestInAssets as getRequest,
  postRequestInAssets as postRequest,
  putRequestInAssets as putRequest,
} from "services/axiosAssetsBaseClient";
import Master from "../Master";
import { useHistory, Link } from "react-router-dom";
import TableAndSearch from "components/common/TableAndSearch";
import { getRequestInService } from 'services/axiosServiceBaseClient';
import jwt_decode from "jwt-decode";
import { NotificationManager } from "react-notifications";
import ConfirmationDialog from "../../components/common/ConfirmDialog";

var id = undefined;
var enterpriseName = '';
var action = 'Submit';
var title = "Add Zone";
var view = undefined;
var onlyView = false;
var readOnlyField = false;
var userEnterprise = '';

var headerFilterParms;
var headerFilter = false;
var tempSearch;
var tableSearchKey;

function AddZoneForm(props) {

  const initialFormValues = {
    zone: "",
    siteId: "",
    enterprise: "",
    zoneStatus: "",
  };

  const [zoneData, setZoneData] = useState([]);
  const [searchString, setSearchString] = useState("");

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [enterpriceName, setEnterpriceName] = useState([]);
  const [zoneStatus, setZoneStatus] = useState([]);
  const [zoneCount, setZoneCount] = useState(0);
  const [recordUpdate, setRecordUpdate] = useState(false);
  const [tempSwap, setTempSwap] = useState([]);

  const history = useHistory();




  const getZoneDataByID = async (id, enterpriseName) => {
    await getRequest(`zone/getZoneById?enterprise=${enterpriseName}&id=${id}`)
      .then((res) => {
        if (res.data != null) {
          patchForm(res.data);
          console.log()
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const patchForm = (data) => {
    console.log(data, "DTAA")
    setFormValues({
      zone: data?.zone?.name ? data?.zone?.name : data.zone,
      siteId: data?.siteIds ? data?.siteIds[0] :data.sites,
      id: data?.zone?.id ? data?.zone?.id :data.zoneId,
      enterprise: data?.zone?.enterprise,
      zoneStatus: data?.zone?.isActive ? data?.zone?.isActive : data.isActive ? data.isActive : false,
    });
  };

  id = props.match.params.id;
  view = props.match.params.view;

  const routeChange = () => {
    history.push({
      pathname: "/Assets",
      state: { table:0, compomentRenderType: "view" }
    });

    // if (props?.location?.state?.trigger == "Update") {
    //   history.push("/Assets/AddZone")
    //   window.location.reload();
    // } else {
    //   // history.push("/Assets");
    //   history.push({
    //     pathname: "/Assets",
    //     state: {compomentRenderType : "view"}
    //   });
    // }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let result = validate(formValues);

    if (Object.values(result).every((x) => x === "")) {
      // const obj = {
      //   zone: {
      //     id: formValues?.id,
      //     name: formValues.zone,
      //   },
      //   siteId: formValues.siteId,
      //   enterprise: formValues.enterprise,
      //   zoneStatus: formValues.zoneStatus,
      // };

      const obj = {
        zone: {
          id: formValues?.id,
          name: formValues.zone.trim(),
          enterprise: formValues.enterprise,
          isActive: formValues.zoneStatus,
        },
        // siteId: formValues.siteId,

      };
      if (action === "Update") {
        try {
          putRequest(`zone/updateZone?enterprise=${formValues.enterprise}`, obj).then((res) => {
            if (res && res?.data) {
              history.push({
                pathname:"/Assets",
                state: {compomentRenderType : "view"}})
              notificationService.showNonBlacklisted(res?.config?.url, res?.data?.message);
            
            }
          })
            .catch(error => {
              console.log(error, "ERROR")
              notificationService.showNonBlacklistedError(error?.config?.url, error?.response?.data?.message);
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          postRequest("zone/addZone", obj).then((res) => {
            if (res && res?.data) {
              history.push("/Assets");
              notificationService.showNonBlacklisted(res?.config?.url, res?.data?.message);
            }
          })
            .catch(error => {
              console.log(error, "ERROR")
              notificationService.showNonBlacklistedError(error?.config?.url, error?.response?.data?.message);
              return error;
            });
        } catch (error) {
          reset();
          console.log(error);
        }
      }
    }

    console.log(`form values -----> ${JSON.stringify(formValues)} `);
    console.log(`form errors -----> ${JSON.stringify(formErrors)} `);
  };

  const validate = (formValues) => {
    console.log(formValues, "tetsinf")
    const errors = {};
    if (!formValues.zone || formValues.zone === "-1") {
      errors.zone = "Zone name is required!";
    }else if (!/^[ A-Za-z0-9-_.&']*$/i.test(formValues.zone)) {
      errors.zone =  "-_&. are the only allowed special characters!";
    }else if(formValues?.zone.trim() === "") {
      errors.zone = "This is not a valid zone name";
    } else {
      errors.zone = "";
    }

    if (!formValues.enterprise) {
      errors.enterprise = "Enterprise name is required!";
    } else {
      errors.enterprise = "";
    }
    if (formValues.zoneStatus === '') {
      errors.zoneStatus = "Zone status is required!";
    } else {
      errors.zoneStatus = "";
    }

    // if(!formValues.siteId || formValues.siteId === "-1") {
    //   errors.siteId = "Site Name is required!";
    // } else {
    //   errors.siteId = "";
    // }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const { accessToken } = token;
    const decodedToken = jwt_decode(accessToken);
    userEnterprise = decodedToken.group[0];
    formValues.enterprise = userEnterprise;
    enterpriseName = userEnterprise;
   
    if (recordUpdate) {
      window.scrollTo({ top: 0 });
      setRecordUpdate(false);
    }
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Zone";
      readOnlyField = false;
      onlyView = false;
      getZoneDataByID(id, enterpriseName);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      title = "View Zone";
      readOnlyField = false;
      onlyView = true;
      getZoneDataByID(id, enterpriseName);
    } else {
      title = "Add Zone";
      onlyView = false;
      readOnlyField = false;
      action = "Submit";
    }
  }, [recordUpdate]);

  return (
    <>
      <div  id="AddZone_form" className={cn(styles.flex_item1)}>
        <div id="AddZone_form_block" className={cn(styles.flex1)}>
          <h2 id="AddZone_form_Heading" className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Zones"}
          </h2>

          <div id="AddZone_form_layout" className={cn(styles.group, styles.group_layout)}>
            <form>
              <div id="AddZone_form_layout1" className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 id="AddZone_form_Title" className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {title}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)}></hr>

                <div  id="AddZone_parameter_layout" className={cn(styles.flex2, styles.flex2_layout)}>
                  <div id="AddZone_Zone_block" className={cn(styles.flex2_item)}>
                    <div id="AddZone_Zone" className={cn(styles.block3, styles.block3_layout)}>
                      <div
                      id="AddZone_label_ZoneName"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Zone Name*"}
                      </div>
                      <input
                      id="AddZone_input_ZoneName"
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.zone}
                        onChange={handleChange}
                        maxLength="50"
                        disabled={onlyView || readOnlyField}
                      />
                    </div>
                    <p>{formErrors.zone}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  {/* <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Link Site"}
                      </div>
                        <select
                          name="siteId"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select,
                          )}
                          value={formValues.siteId}
                          onChange={handleChange}
                          disabled={onlyView}
                        >
                          <option value="-1">Select Site</option>
                          {sitesList.map((obj) => {
                            return <option value={obj.id}>{obj.name}</option>;
                          })}
                        </select>
                    </div>
                    <p>{formErrors.siteId}</p>
                  </div> */}
                  <div id="AddZone_enterprise_block" className={cn(styles.flex2_item)}>
                    <div id="AddZone_enterprise" className={cn(styles.block3, styles.block3_layout)}>
                      <div
                      id="AddZone_label_enterpriseName"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Enterprise Name*"}
                      </div>
                      <input
                      id="AddZone_input_enterpriseName"
                        name="enterprise"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.enterprise}
                        onChange={handleChange}
                        disabled
                      />
                      {/* <select
                          name="enterprise"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select,
                          )}
                          value={formValues.enterprise}
                          onChange={handleChange}
                          disabled={onlyView}
                          type="select"
                        >
                          <option value="-1">Enterprise Name</option>
                          {enterpriceName?.map((obj) => {
                            return <option value={obj.enterpriseName}>{obj.enterpriseName}</option>;
                          })}
                        </select> */}
                    </div>
                    <p>{formErrors.enterprise}</p>
                  </div>
                </div>

                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div id="AddZone_ZoneStatus_block" className={cn(styles.flex2_item)}>
                    <div id="AddZone_ZoneStatus" className={cn(styles.block3, styles.block3_layout)}>
                      <div
                      id="AddZone_label_ZoneStatus"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Zone Status*"}
                      </div>
                      <select
                        name="zoneStatus"
                        className={cn(
                          styles.line1,
                          styles.line1_layout,
                          styles.style_select
                        )}
                        value={formValues.zoneStatus}
                        onChange={handleChange}
                        disabled={onlyView}
                        type="select"
                      >
                        <option value="" selected>Select Status</option>
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                        {/* {zoneStatus?.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })} */}
                      </select>
                    </div>
                    <p>{formErrors.zoneStatus}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}></div>
                </div>

                <div id="AddZone_Button_block" className={cn(styles.flex9, styles.flex9_layout)}>
                  <div id="AddZone_Button_layout" className={cn(styles.flex9_item)} onClick={routeChange}>
                    <div id="AddZone_Button_layout1" className={cn(styles.block7, styles.block7_layout)}>
                      <h5
                      id="AddZone_BackButton_Title"
                        className={cn(
                          styles.highlights1,
                          styles.highlights1_layout
                        )}
                      >
                        {onlyView ? "Back" : "Cancel"}
                      </h5>
                    </div>
                  </div>

                  <div className={cn(styles.flex9_spacer)} />
                  {action !== "view" ? (
                    <div  id="AddZone_SubmitButton" className={cn(styles.flex9_item)}>
                      <div
                       id="AddZone_SubmitButton_BackGround"
                        onClick={handleSubmit}
                        className={cn(styles.block9, styles.block9_layout, styles.submit_layout)}
                        style={{
                          backgroundColor: "#315CBB",
                        }}
                      >
                        <h5
                         id="AddZone_SubmitButton_Title"
                          className={cn(
                            styles.highlights2,
                            styles.highlights2_layout
                          )}
                        >
                          {action}
                        </h5>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
        </div>
      </div>
    </>
  );
}


export default function AddZone(props) {
  return (
    <>
      <Master opts={props} screen={AddZoneForm} showStatus={false} />
    </>
  );
}

AddZone.inStorybook = true;





